<template lang="pug">
  v-container.home-container.pb-10
    v-row.mx-auto(style="contain: content;")
      v-col(cols="12" xs="12" sm="12" md="8")
        //- Banner
        v-skeleton-loader.my-3.mx-auto(v-if="loadingComponents" tile type='card' transition='scale-transition' height="100" width='100%')
        img.w-80.rounded-lg(v-else src="@/assets/images/home/banner.png" style="height: 120px; width: 100%;")
        //- Movements
        v-skeleton-loader.my-3.mx-auto(v-if="loadingComponents" tile type='card' transition='scale-transition' height="100" width='100%')
        Movements(v-else)
        //- Shop
        v-row
          v-col(cols="12" xs="12" sm="12" md="6")
            v-skeleton-loader.my-3.mx-auto(v-if="loadingComponents" tile type='card' transition='scale-transition' height="370" width='100%')
            Shops(v-else)
          v-col(cols="12" xs="12" sm="12" md="6")
            v-skeleton-loader.my-3.mx-auto(v-if="loadingComponents" tile type='card' transition='scale-transition' height="370" width='100%')
            Summary(v-else)
      //- Options
      v-col.py-1(cols="12" xs="12" sm="12" md="4")
        v-card.my-0.rounded-lg()
          v-card-title.justify-center.main-title-primary.my-3 ¿Qué quieres hacer?
          v-row.px-6
            v-col.circular-center-column(cols="4" v-for="card in categories")
              v-card.circular-card.d-flex.align-center.justify-center(:to="'/dashboard/'+card.link")
                v-img(:src="card.icon" contain height="50" v-if="card.name !== 'Tutoriales'")
                v-icon(v-else size="50" color="primary") {{card.icon}}
              p(style="font-size: 12px") {{card.name}}
        v-card.rounded-lg.pb-2.post-card
          v-card-title.justify-center.main-title-primary.my-3 Visita tus puntos de venta
          v-card.px-5.d-flex.justify-center.align-center(flat href="https://pos-tender.web.app/" target="_blank")
            img.rounded-lg(src="@/assets/images/home/button-pos.png" style="width: 300px; height: 80px;")
</template>

<script>
  export default {
    name: 'Home',
    components: {
      Movements: () => import('@/components/custom/metrics/movement_summary'),
      Shops: () => import('@/components/custom/Shops'),
      Summary: () => import('@/components/custom/metrics/summary_transactions'),
    },

    data: () => ({
      loadingComponents: false,
    }),
    computed: {
      isMobile () {
        return window.innerWidth < 1024
      },
      categories () {
        return [
          {
            name: 'Productos',
            icon: require('@/assets/icons/home/productos.png'),
            link: 'products',
          },
          {
            name: 'Métricas',
            icon: require('@/assets/icons/notifications/withdraw.png'),
            link: 'metrics',
          },
          {
            name: 'Ventas',
            icon: require('@/assets/icons/home/ordenes.png'),
            link: 'transactions/sales',
          },
          {
            name: 'Compras',
            icon: require('@/assets/icons/home/cargarinventario.png'),
            link: 'transactions/purchases',
          },
          {
            name: 'Clientes',
            icon: require('@/assets/icons/actions/provider.png'),
            link: 'clients',
          },
          {
            name: 'Proveedores',
            icon: require('@/assets/products/prod-simple-icon.png'),
            link: 'providers',
          },
          {
            name: 'Colaboradores',
            icon: require('@/assets/icons/actions/colaborators.png'),
            link: 'collaborators',
          },
          {
            name: 'Traslados',
            icon: require('@/assets/icons/home/proveedores.png'),
            link: 'transactions/transfers',
          },
          {
            name: 'Tutoriales',
            icon: 'mdi-youtube',
            link: 'tutorials',
          },
        ]
      },
    },
    mounted () {
      const vm = this
      vm.loadingComponents = true
      setTimeout(() => {
        vm.loadingComponents = false
      }, 3000)
    },
    methods: {},

  }
</script>
<style scoped lang="scss">
  .post-card{
    height: 22%;
    @media(min-width: 760px) {
    }
    @media(max-width: 1150px) {
      height: 30% !important;
    }
  }
  .tutorial{
    z-index:1;
    height: 100%;
    &:after{
      content:'';
      position:absolute;
      right: -5px;
      width: 40px;
      height: 40px;
      top: 50%;
      bottom: 50%;
      transform: rotate(45deg);
      background-color: inherit;
      margin: auto;
      z-index: -1;
    }
  }
  .shop {
    box-sizing: border-box;
    cursor: pointer;
    border: 2px #00b4c6 solid;
    margin: 2px;
    background: #fff;
    border-radius: 10px;

    &__main-title {
      font-size: 2.5rem;
      padding-left: 4px;
      font-weight: 800;
    }

    &__img {
      width: 100%;
      height: 10rem;
      object-fit: cover;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
    }

    &__title {
      font-size: 1.5rem;
      display: block;
      text-align: center;
    }
  }
  .home {
    &__greeting {
      text-align: center;
      color: #30b5bb;
      margin: .5rem;
      &--question {
        color:#a3a4a5;
      }
    }

    &__underline {
      position: relative;

      &:after {
        content:' ';
        position: absolute;
        top:120%;
        left:50%;
        width: 8rem;
        border:2px solid #30b5bb;
        border-radius:4px;
        transform:translateX(-50%);
      }
    }
  }

  .option {
    &__container {
      margin: 0 .5rem;
      background: #fff;
      border-radius: 10px;
      box-shadow: 0 .9375rem 2.5rem rgba(#000, .15);
    }

    &__title {
      color: #c5c5c6;
      font-size: 0.8rem;
      text-align: center;
    }

    &__img {
      height: 50px;
      display: block;
      margin-left: auto;
      margin-right: auto;

      &--shop {
        width: 50px;
        border-radius: 50%;
        object-fit: cover;
      }
    }
  }
</style>
